<template>
  <div class="regulatory-header">
    <span></span>
    <div v-if="displayedTime || displayedTime == 0">
      <font-awesome-icon icon="fa-solid fa-stopwatch" />
      <span style="padding-left: 8px;">{{displayedTime | convertTimeFilter}}</span>
    </div>
    <button @click="eventHome" class="home-button"><font-awesome-icon icon="fa-solid fa-house" color="white" size="xl"/></button>
  </div>
</template>

<script>
import convertTimeFilter from '@/mixins/filterTime';
import { disconnectWSAPI } from '../../../helper/api/disconnectWS';

export default {
  name: 'CZRegulatoryHeader',
  mixins: [convertTimeFilter],
  props: { displayedTime: { type: [Number, Boolean], default: false } },
  methods: {
    async eventHome () {
      const { closeurl, exitUrl } = this.$route.query;
      this.$store.getters.isFullScreen && await this.$store.dispatch('closeFullScreen');

      await disconnectWSAPI(this.popToken, 'HOME')

      this.isLogoutBeaconSent = true

      window.top.location.href = closeurl ? closeurl : exitUrl;
    }
  }
}
</script>

<style lang="scss" scoped>
.regulatory-header {
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: #17171b;
  color: white;

  .home-button {
    border:none;
    background-color: transparent;
    cursor: pointer;
  }
}
</style>
